/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect } from 'react';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import PropTypes from 'prop-types';
import { isProduction } from 'src/config/index';
import { withFormikDevtools } from 'formik-devtools-extension';
import RoutingUtil from 'src/utils/RoutingUtil';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { shallowEqual } from 'recompose';
import FormikInput from 'src/components/formik/FormikInput';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import UserDropDown from 'src/business-components/UserDropDown';
import { includeStamp } from 'src/utils/StampUtils';
import CustomerDropDown from 'src/business-components/CustomerDropDown';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import CompanyProductsDropDown from 'src/business-components/CompanyProductsDropDown';
// import CommissionDropDown from 'src/business-components/CommissionDropDown';
import FormikSelect from 'src/components/formik/FormikSelect';
import CatalogueVehicleInsuranceDropDown from 'src/business-components/CatalogueVehicleInsuranceDropDown';
import UsePermission from 'src/hoc/UsePermission';
import { caseResetAction, caseUpsertAction } from './actions/CaseActions';
import { CaseYupSchema } from './CasePropTypes';
import FileContainer from '../files-container/FileContainer';
import {
    CASE_NEXT_STAGES, CASE_TYPES_LIST, StageTypesData, STAGE_TYPES,
} from './CaseConstants';
import { PRODUCT_CATEGORY_TYPES_LIST, PRODUCT_CATEGORY_TYPES } from '../product-container/ProductConstants';
import CaseMetaFactory from './factory/CaseMetaFactory';
import { headerShowAction } from '../header-container/actions/HeaderActions';
import CrossSaleContainer from '../cross-sale-container/CrossSaleContainer';
import FormikCheckBox from 'src/components/formik/FormikCheckBox';
import { VEHICLE_STATUS_TYPES_LIST } from 'src/containers/product-container/ProductConstants';
import MastersDropDown from 'src/business-components/MastersDropDown';
import { MASTERS_TYPES } from 'src/containers/masters-container/MastersConstants';
import SlabDropDown from 'src/business-components/SlabDropDown';
import { slabSearchApi } from "src/api/InsuranceSlabApi";
import { set } from "lodash";

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
        onStageChange,
        setFieldValue,
        onSlabChange,
    } = props;

    useEffect(() => {
        if (values.slabCode) {
            onSlabChange(values, setFieldValue);
        }
    }, [values.slabCode, onSlabChange]);


    let caseNextStages = null;

    const hasStatusChangeRights = UsePermission({
        scope: 'flow.case_manager.manage.change_status',
    });
    if (CASE_NEXT_STAGES[values.stage]) {
        const stageOptions = CASE_NEXT_STAGES[values.stage].map((stage) => (
            <button
                key={values.stage}
                type="button"
                className="btn btn-secondary"
                onClick={() => onStageChange(values.stage, values.cancelRemarks, values.cancelCharges)}
            >
                {stage.label}
            </button>
        ));

        caseNextStages = (
            <>
                <div className="form-group col-md-2">
                    <label>Next Case Stage</label>
                    <div>
                        <div
                            className="btn-group"
                            role="group"
                            aria-label="Basic example"
                        >
                            {stageOptions}
                        </div>
                    </div>
                </div>
                {
                    (values.stage === STAGE_TYPES.COMPLETED) ?
                        <>
                            <div className="form-group col-md-3">
                                <label>Reason/Remarks</label>
                                <FormikInput
                                    name="cancelRemarks"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label>Charge(Amount in Rs.)</label>
                                <FormikInput
                                    name="cancelCharges"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </>
                        : null
                }

            </>
        );
    }

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <Form autoComplete="disabled">
                        <h5 className="card-title">Case Details</h5>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Current Case Stage</label>
                                <div
                                    className="form-control"
                                    readOnly
                                >
                                    {values.stage || StageTypesData.INQUIRY}
                                </div>
                            </div>
                            {hasStatusChangeRights ? caseNextStages : null}
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-2">
                                <label>Case Code</label>
                                <FormikInput
                                    disabled
                                    placeholder="Auto Generated"
                                    name="caseCode"
                                    type="text"
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group col-md-2">
                                <label>Case Type</label>
                                <FormikSelect
                                    items={CASE_TYPES_LIST}
                                    name="caseType"
                                    className="form-control"
                                    disabled={Boolean(values._id)}
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Assigned Agent</label>
                                <UserDropDown
                                    name="agentId"
                                    value={values.agentId}
                                />
                            </div>
                            <div className="form-group col-md-4">
                                <label>Frontend Manager</label>
                                <UserDropDown
                                    name="reportingManagerId"
                                    value={values.reportingManagerId}
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Backend Manager</label>
                                <UserDropDown
                                    name="reportingManagerBackendId"
                                    value={values.reportingManagerBackendId}
                                />
                            </div>

                            <div className="form-group col-md-6">
                                <label>Customer</label>
                                <CustomerDropDown
                                    name="customerId"
                                    value={values.customerId}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-2">
                                <label>Category</label>
                                <FormikSelect
                                    items={PRODUCT_CATEGORY_TYPES_LIST}
                                    name="productCategory"
                                    className="form-control"
                                />
                            </div>


                            <div className="form-group col-md-3">
                                {values.productCategory === 'CAR_LOAN' && (
                                    <>
                                        <label>Loan Provider</label>
                                        <CompanyDropDown
                                            name="companyId"
                                            value={values.companyId}
                                        />
                                    </>
                                )}
                                {values.productCategory === 'VEHICLE_INSURANCE' && (
                                    <>
                                        <label>Insurance Provider</label>
                                        <CompanyDropDown
                                            name="companyId"
                                            value={values.companyId}
                                        />
                                    </>
                                )}
                                {values.productCategory !== 'CAR_LOAN' && values.productCategory !== 'VEHICLE_INSURANCE' && (
                                    <>
                                        <label>Company</label>
                                        <CompanyDropDown
                                            name="companyId"
                                            value={values.companyId}
                                        />
                                    </>
                                )}
                            </div>


                            {values.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE && (
                                <div className="form-group col-md-3">
                                    <label>Policy Type</label>
                                    <MastersDropDown
                                        name="policyType"
                                        value={values?.policyType || ''}
                                        masterType={MASTERS_TYPES.POLICY_TYPE}
                                    />
                                </div>)}

                            {values.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE && (
                                <div className="form-group col-md-4">
                                    <label>Slab Code</label>
                                    <SlabDropDown
                                        name="slabCode"
                                        value={values.slabCode}
                                        whereConditions={{
                                            ...(values?.companyId && { companyId: values.companyId }),
                                            ...(values?.policyType && { policyType: values.policyType }),
                                        }}
                                    />

                                </div>)}
                                
                            {values.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE && (
                                <div className="form-group col-md-3">
                                    <label>Business Type</label>
                                    <FormikSelect
                                        items={VEHICLE_STATUS_TYPES_LIST}
                                        name="vehicleStatus"
                                        className="form-control"
                                    />
                                </div>)}
                            {values.productCategory !== PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE && (
                                <div className="form-group col-md-3">
                                    <label>Product</label>
                                    <CompanyProductsDropDown
                                        name="productId"
                                        value={values.productId}
                                        companyId={values.companyId}
                                        productCategory={values.productCategory}
                                    />
                                </div>)}
                            {values.productCategory !== PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE && (
                                <div className="form-group col-md-12">
                                    <label>Catalogue</label>
                                    <CatalogueVehicleInsuranceDropDown
                                        name="catalogueId"
                                        value={values.catalogueId}
                                        companyId={values.companyId}
                                        productId={values.productId}
                                        productCategory={values.productCategory}
                                    />
                                </div>)}
                        </div>

                        {/* <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Agent Commission Slab</label>
                                <CommissionDropDown
                                    name="agentCommissionId"
                                    value={values.agentCommissionId}
                                />
                            </div>
                        </div> */}
                        <div className="form-row">
                            <div className="form-group col-md-3">
                                <label>Is Payout </label>
                                <FormikCheckBox
                                    className="ml-2 big-checkbox"
                                    name="isPayout"
                                />
                            </div>
                        </div>


                        {
                            values.isPayout ? (
                                <>
                                    <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <label> Bank/Insurance Company Payout (Commission %)</label>
                                            <FormikInput
                                                name="companyCommissionPercentage"
                                                type="number"
                                                className="form-control"
                                                value={values?.companyCommissionPercentage}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group col-md-4">
                                            <label>Agent Payout (Commission %)</label>
                                            <FormikInput
                                                name="agentCommissionPercentage"
                                                type="number"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : null
                        }


                        <CaseMetaFactory
                            values={values}
                            setFieldValue={setFieldValue}
                        />
                        {/* values.stage === STAGE_TYPES.COMPLETED || */}
                        {values.stage === STAGE_TYPES.CANCELED ? (
                            <div
                                className="alert alert-success"
                                role="alert"
                            >
                                Not updates are allowed on this case. This case is
                                {' '}
                                {values.stage}
                            </div>
                        ) : (
                            <div className="text-center py-4 mt-3">
                                <FormikCreateSearchClear
                                    isSubmitting={isSubmitting}
                                    isUpdate={Boolean(values._id)}
                                    onSearch={onSearch}
                                    onClear={onClear}
                                    resetForm={resetForm}
                                    values={values}
                                    submitScope="flow.case_manager.manage.submit"
                                    searchScope="flow.case_manager.manage.search"
                                />
                            </div>
                        )}
                    </Form>
                </div>

                <div className="p-3">
                    <CrossSaleContainer
                        className="mt-3"
                        is_carLoan={values._id}//(values.productCategory === PRODUCT_CATEGORY_TYPES.CAR_LOAN)
                        refId={values._id}//values.companyId
                        source="case"
                        title="Cross Sell Details"
                    />
                    <div className="form-group">
                        <RemarkComponent
                            title="Case Remarks"
                            refId={values._id}
                            source="cases"
                        />
                    </div>

                    <FileContainer
                        className="mt-3"
                        refId={values._id}
                        source="case"
                        title="Case Files"
                    />
                </div>
            </div>

        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        agentId: PropTypes.string,
        caseCode: PropTypes.string,
        customerId: PropTypes.string,
        companyId: PropTypes.string,
        productId: PropTypes.string,
        catalogueId: PropTypes.string,
        // agentCommissionId: PropTypes.string,
        stage: PropTypes.string,
        productCategory: PropTypes.string,
        vehicleStatus: PropTypes.string,
        insurancePlans: PropTypes.string,
        companyCommissionPercentage: PropTypes.number,
        agentCommissionPercentage: PropTypes.number,
    }).isRequired,
    onStageChange: PropTypes.func.isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => { };

const CaseForm = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.CaseReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        if (values.catalogueId === "") values.catalogueId = null
        if (values.chasisNumber === "") values.chasisNumber = null
        includeStamp(values);

        dispatch(caseUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback(({
        contactName,
        phone,
        email,
        company,
        designation,
        agentId,
        reportingManagerId,
        reportingManagerBackendId,
        companyId,
    }) => {
        history.push(RoutingUtil.caseSearch({
            contactName,
            phone,
            email,
            company,
            designation,
            agentId,
            reportingManagerId,
            reportingManagerBackendId,
            companyId,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(caseResetAction());
    }, [
        dispatch,
    ]);

    const onStageChange = useCallback((stage, cancelRemarks, cancelCharges) => {
        if (currentRecord.stage === STAGE_TYPES.QUOTATION && stage !== STAGE_TYPES.CANCELED) {
            const approvedQuotation = currentRecord.quotations?.filter((quotation) => quotation.isApproved);
            if (approvedQuotation.length < 1) {
                dispatch(headerShowAction({
                    data: 'Please approve a quotation before moving to the next stage.',
                }));
                return;
            }
        }

        const newRecord = {
            ...currentRecord,
            stage,
            cancelRemarks,
            cancelCharges
        };
        includeStamp(newRecord);
        dispatch(caseUpsertAction(newRecord));
    }, [
        dispatch,
        currentRecord,
    ]);

    const onSlabChange = useCallback(async (values, setFieldValue) => {
        if (!values.slabCode) return;

        try {
            // API call to get slab details based on _id
            const response = await slabSearchApi({
                where: { _id: values.slabCode },
                autopopulate: false,
            });

            // Extract the array from the response
            const slabDetailsArray = response?.data?.data?.data || [];

            if (slabDetailsArray.length > 0) {
                const selectedSlab = slabDetailsArray[0];
                // setFieldValue to update Formik state so UI reflects changes
                setFieldValue("isPayout", true);
                setFieldValue("companyId", selectedSlab.companyId);
                setFieldValue("policyType", selectedSlab.policyType);
                setFieldValue("rtoZone", selectedSlab.rtoZone);
                setFieldValue("companyCommissionPercentage", selectedSlab.slabRate);
                setFieldValue("ncbPercentage", selectedSlab.ncbValue);
            }
        } catch (error) {
            console.error("Error fetching slab details:", error);
        }
    }, []);



    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={CaseYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    onStageChange={onStageChange}
                    onSlabChange={onSlabChange}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default CaseForm;
